module.exports = __webpack_public_path__ + "img/logo2.8b750774.png";